<template>
    <div class="vk-table">
      <el-table :data="tableData" header-row-class-name="vk-table-header" v-loading="loading" stripe >
        <template v-for="item in columns" :key="item.label">
          <el-table-column
            v-if="item.type === 'index'"
            type="index"
            class-name="index-column"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :min-width="item.minWidth"
            :align="item.align || alignDefault"
          />
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :align="item.align || alignDefault"
          >
            <template #default="scope">
              <template v-if="item.slotName">
                <slot :name="item.slotName" :scope="scope" />
              </template>
              <template v-else>
                {{
                  item.formatter
                    ? item.formatter(scope.row)
                    : scope.row[item.prop] || scope.row[item.prop] === 0
                      ? scope.row[item.prop]
                      : item.prop
                        ? "--"
                        : ""
                }}
              </template>
            </template>
          </el-table-column>
        </template>
        <template #empty>
            <div class="empty-container">
              <vkm-svg icon-name="none-data" class="icon" />
              <span class="title">暂无数据</span>
            </div>
        </template>
      </el-table>
      <el-pagination
        :class="['pagination-style',{'small-size-pagination':sizeType ==='small','default-size-pagination':sizeType === 'default'}]"
        v-if="showPagination && pagination.totalCount > 0"
        :page-sizes="pageSizes"
        background
        :layout="layOut"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-bind="$attrs"
      />
  </div>
</template>
  
  <script setup name="vk-table">
  import { ref, reactive, defineProps, defineEmits, computed, } from "vue";
  import { ElPagination,ElTable,ElTableColumn} from 'element-plus'
  import Pagination from "@/config/pagination";

  const props = defineProps({
    tableData: {
      type: Array,
      required: true,
      default: () => []
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    alignDefault: {
      type: String,
      default: "center"
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 50]
    },
    layOut: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    pagination: {
      type: Object,
      default: () => new Pagination()
    },
    loading: {
      type: Boolean,
      default: false
    },
    sizeType:{
      type:String,
      default:'default',//default , small
    }
  });
  const emits = defineEmits(["row-click", "sizeChange", "pageChange"]);
  
  function handleRowClick(row, column, event) {
    emits("rowClick", row, column, event);
  }
  function handleSizeChange(val) {
    window?.playClick()
    emits("sizeChange", val);
  }
  function handleCurrentChange(val) {
    window?.playClick()
    emits("pageChange", val);
  }
  </script>
  
  <style scoped lang="scss">
  .vk-table {
    position: relative;
    width: 100%;
    height: 100%;
    .el-table{
        width: 100%;
        height: 100% !important;
        box-sizing: border-box;
        /* Black 10 */
        border: none;
        background-color: transparent !important;
        --el-table-border-color: transparent!important;
        --el-table-header-text-color:$White6;
        --el-table-row-hover-bg-color:transparent!important;
        --el-fill-color-lighter:#323843;
    }
    ::v-deep .el-scrollbar__view{
        height: 100%!important;
        width: 100%!important;
    }
    ::v-deep .el-table__cell{
      padding: 20px 10px !important;
    }
    
    ::v-deep .el-table .cell{
      @include font18($f:'Har');
      font-weight: 500;
      padding: 0 !important;
      color: $White6;
    }
    ::v-deep .el-table .el-table__row .cell{
      color: $White9;
    }
    ::v-deep .el-table__header-wrapper{
      border-radius: 8px 8px 0px 0px !important;
    }
    ::v-deep .el-table th.el-table__cell{
      background-color: #323843 !important;
    }
    ::v-deep .el-table tr{
      background-color: transparent!important;
    }
    ::v-deep .el-table__row--striped{
      --el-table-row-hover-bg-color:rgba(0, 0, 0, 0.3)!important;
    }

    .empty-container{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon{
        width: 64px;
        height: 64px;
        margin-bottom: 12px;
      }
      .title{
        @include font18($f: 'Har');
        font-weight: 500;
        color: $White6;
      }
    }
    .pagination-style{
      position: absolute;
      right: 0;
      bottom: 0px;
      margin-top: 16px;
    }
  }
  </style>
  